<template>
  <div>
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업 현황</h5>
      <div class="writeGridContainer">
        <div>
          <div>작업공정</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_1" />
        </div>
        <div>
          <div>담당부서</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_2 " />
        </div>
        <div>
          <div>작업일자</div>
          <div class="time">
            <date-selector v-model="work.inputA_3" :readonly="board.readonly" />
            <p>~</p>
            <date-selector v-model="work.inputA_4" :readonly="board.readonly" />
          </div>
        </div>

        <div>
          <div>작업시간</div>
          <div class="time">
            <time-selector v-model="work.inputA_5" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="work.inputA_6" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_7 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_7 " />
        </div>
        <div>
          <div>신호방법</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_8 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_8 " />
        </div>

        <div class="writeGridLineItem">
          <div>작업내용</div>
          <span v-if="isPrint" class="print-textarea"> {{ work.inputA_9 }} </span>
          <ml-textarea v-else rows="5" v-model="work.inputA_9" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 명단 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="작업인원 <span style='color:#4839EB;'>※유도자(신호)는 작업지휘자와 중복 지정 가능</span>"
      title-type="html"
      :tableData="[
        { id: 'input1', title: '직책', type: 'text', placeholder: '' },
        { id: 'input2', title: '성명', type: 'text', placeholder: '' },
        { id: 'input3', title: '연락처', type: 'text', placeholder: '' },
        {
          id: 'input4',
          title: '보호구 지급',
          type: 'select',
          selectData: [
            '지급',
            '미지급',
          ],
          placeholder: '선택',
        },
         {
          id: 'input5',
          title: '교육여부',
          type: 'select',
          selectData: [
            '실시',
            '미실시',
          ],
          placeholder: '선택',
        },
        { id: 'input6', title: '필요자격여부', type: 'textarea', placeholder: '' },
      ]"
      :mobile="['input1', 'input2']"
      v-model="work.workerList"
      class="mt-4"
    />

    <div class="mt-8px">
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>교육내용</div>
          <span v-if="isPrint" class="print-textarea"> {{ work.workerComment1 }} </span>
          <ml-textarea v-else rows="5" v-model="work.workerComment1" :readonly="board.readonly" placeholder="작업계획서 내용(안전수칙, 재해예방대책 등), 보호구 착용방법 등"/>
        </div>
        <div class="writeGridLineItem">
          <div>작업계획(순서)</div>
          <span v-if="isPrint" class="print-textarea"> {{ work.workerComment2 }} </span>
          <ml-textarea v-else rows="5" v-model="work.workerComment2" :readonly="board.readonly" placeholder="작업계획서 내용(안전수칙, 재해예방대책 등), 보호구 착용방법 등"/>
        </div>
      </div>
    </div>


    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 중량물제원<span style="color: #4839EB; font-size: 15px;">※ 중량물 단위별 작성</span></h5>
      <div class="writeGridContainer">
        <div>
          <div>품명</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_1" />
        </div>
        <div>
          <div>중량물 형상</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_2" placeholder="박스형, 봉형, 묶음형 등" />
        </div>
        <div>
          <div>중량물 규격</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_3" placeholder="(너비)×(길이)×(높이)"/>
        </div>

        <div>
          <div>중량</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_4" placeholder="묶음일 경우 묶음 단위 구분"/>
        </div>
        <div>
          <div>1회 운반중량</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_5" placeholder="묶음 단위 중량 등"/>
        </div>

        <div class="writeGridLineItem">
          <div>고정방법</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_6 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_6" />
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기계(장비)제원<span style="color: #4839EB; font-size: 15px;">※ 사용 기계별 작성</span></h5>
      <div class="writeGridContainer">
        <div>
          <div>기계명(장비)</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_1" placeholder="호이스트, 천장크레인, 지게차, 이동식크레인, 타워크레인 등"/>
        </div>
        <div>
          <div>기계번호</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_2" placeholder="대구00고0000"/>
        </div>
        <div>
          <div>모델명</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_3" />
        </div>

        <div>
          <div>기계규격</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_4" placeholder="총 중량, 길이, 너비 등"/>
        </div>
        <div>
          <div>작업능력</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_5" placeholder="정격·적재하중, 최대적재량, 지게차 허용하중 등"/>
        </div>
        <div>
          <div>작업가능 반경</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_6 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_6" />
        </div>

        <div>
          <div>조종(운전)자</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_7 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_7" />
        </div>
        <div>
          <div>조종(운전)자격</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_8 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_8" />
        </div>
        <div>
          <div>보험기간(보험가입증명서 참고)</div>
          <div class="time">
            <date-selector v-model="work.inputC_9" :readonly="board.readonly" />
            <p>~</p>
            <date-selector v-model="work.inputC_10" :readonly="board.readonly" />
          </div>
        </div>

        <div>
          <div>검사기한(유효기간)</div>
          <div class="time">
            <date-selector v-model="work.inputC_11" :readonly="board.readonly" />
            <p>~</p>
            <date-selector v-model="work.inputC_12" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>줄걸이 방법</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_13 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_13" placeholder="해당 시" />
        </div>
        <div>
          <div>운반거리</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_14 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_14" placeholder="수직(높이), 수평 운반거리" />
        </div>

        <div class="writeGridLineItem">
          <div style="line-height: normal;">줄걸이 용구(달기구)</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_15 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_15" placeholder="와이어로프, 클램프, 벨트슬링, 체인슬링, 샤클 등 작업에 사양하는 달기구별 사양 명기(정격하중, 안전계수, 직경, 길이, 안전하중 등)" />
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 재해예방대책<span style="color: #4839EB; font-size: 15px;">※ 해당 사항은 예시 항목으로 실제 현장의 위험요인을 반영해 작성</span></h5>
      <div>
        <table>
          <colgroup>
            <col width="200" />
            <col />
            <col />
            <col width="300" />
          </colgroup>
          <thead>
            <tr>
              <th>구분</th>
              <th>유해·위험요인</th>
              <th>재해예방대책</th>
              <th>비고</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>작업 전 점검사항</th>
              <td colspan="2" class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_1_1" :readonly="board.readonly" placeholder="예) 중량물 취급의 올바른 자세 및 복장 상태 확인
예) 보호구 지급·착용 상태 확인"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_1_2" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>추락 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_2_1" :readonly="board.readonly" placeholder="예) 중량물 유도작업 중 단부에서 떨어짐"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_2_2" :readonly="board.readonly" placeholder="예) 위험 구역 경고 시설물 설치
예) 안전난간 설치 및 보호구 지급·착용"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_2_3" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>낙하물 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_3_1" :readonly="board.readonly" placeholder="예) 인양 중인 철근더미가 떨어짐
예) 훅 해지장치가 설치되지 않은 훅에서 벨트슬링이 이탈해 중량물 떨어짐"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_3_2" :readonly="board.readonly" placeholder="예) 급회전, 급정지 등 급격한 조작 금지
예) 인양물 고정 철저
예) 훅 해지장치 설치 및 정상 작동 관리"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_3_3" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>전도 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_4_1" :readonly="board.readonly" placeholder="예) 중량물 인양 작업 중 이동식크레인 넘어짐"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_4_2" :readonly="board.readonly" placeholder="예) 작업 전 이동식크레인 작업능력 검토
예) 철판 설치 등 지반 지내력 확보
예) 아웃트리거 설치"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_4_3" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>협착 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_5_1" :readonly="board.readonly" placeholder="예) 중량물(화물) 운반 중인 지게차에 부딪힘
- 천장크레인에 매달린 중량물에 부딪힘"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_5_2" :readonly="board.readonly" placeholder="예) 유도자 배치 및 타 작업자 출입통제 실시
예) 인양하부 등 위험구역 출입금지"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_5_3" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>붕괴 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_6_1" :readonly="board.readonly" placeholder="예) 창고에 보관 중인 화물 무너짐"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_6_2" :readonly="board.readonly" placeholder="예) 평평한 바닥에 적재(편하중 발생 방지)
예) 무리한 높이로 고단 적재 금지"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputD_6_3" :readonly="board.readonly" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 운반경로(작업도면) 등</h5>
      <div>
        <table>
          <tbody>
          <tr>
            <th>범 례</th>
          </tr>
          <tr>
            <td>
              <div class="flex" style="align-items: center; justify-content: center;">
                <p class="m-4">▣  장 비 </p>
                <p class="m-4">●  작 업 자</p>
                <p class="m-4">▲  유 도 자</p>
                <p class="m-4">★  작업지휘자 </p>
                <p class="m-4">→  이동경로</p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="grid grid-cols-12 h-upload">
                <div class="col-span-6 upload-content">
                  <div class="upload-content__file">
                    <FileUploader
                      v-if="!isPrint"
                      type="only-image"
                      v-model="work.inputE_1"
                    />
                    <img :src="work.inputE_1.thumb" v-else class="w-full h-full" />
                  </div>
                  <div class="pl-4 pr-4">
                    <ml-textarea rows="5" v-model="work.inputE_2" :readonly="board.readonly" />
                  </div>
                </div>
                <div class="col-span-6 upload-content">
                  <div class="upload-content__file">
                    <FileUploader
                      v-if="!isPrint"
                      type="only-image"
                      v-model="work.inputE_3"
                    />
                    <img :src="work.inputE_3.thumb" v-else class="w-full h-full" />
                  </div>
                  <div class="pl-4 pr-4">
                    <ml-textarea rows="5" v-model="work.inputE_4" :readonly="board.readonly" />
                  </div>
                </div>
              </div>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기타 붙임자료 등<span style="color: #4839EB; font-size: 15px;">※ 기계보험, 기계사양서(인양하중표), 작업 전 체크리스트, 안전수칙 등</span></h5>
      <div>
        <table>
          <colgroup>
            <col width="200" />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th>구분</th>
            <th>작성 시 참고사항</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>작성 시기</th>
            <td>
              <div class="p-2" style="text-align: start;">
                <p>- 일상작업으로 작업장소와 내용, 인원변동 없을 경우 <b>반기 1회 작성</b></p>
                <p>- 작업장 내 <b>구조, 설비 및 작업방법이 변경</b>되었을 때 작성</p>
                <p>- <b>작업장소 또는 화물의 상태가 변경</b>되었을 때 작성</p>
                <p>- 작업장비의 <b>운전원 교체, 정기검사, 보험기한 연장 시</b> 재작성</p>
              </div>
            </td>
          </tr>
          <tr>
            <th>필수 첨부 서류</th>
            <td>
              <div class="p-2" style="text-align: start;">
                <p>- 기계 <b>등록증</b> (없는 경우 <b>장비안내서</b> 또는 <b>제원표</b>)</p>
                <p>- 기계 <b>검사증</b> (없는 경우 <b>안전인증서</b>)</p>
                <p>- 운전원 <b>자격증 사본</b></p>
                <p>- <b>보험가입 증명서</b></p>
              </div>
            </td>
          </tr>
          <tr>
            <th>계획서 취급보관</th>
            <td>
              <div class="p-2" style="text-align: start;">
                <p>- 작성한 계획서의 <b>원본은 따로 분류</b>하여 보관</p>
                <p>- 계획서는 복사하여 <b>작업장비 별 비치</b></p>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: "WorkHeavyEquipment",
  components: {DateSelector, FileUploader, TableCustom, TimeSelector},
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    work: Object,
  },
  watch: {
    work: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!this.work.workerList || this.work.workerList.length === 0) {
          this.work.workerList = this.initWorkerList;
        }

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      initWorkerList: [
        { input1: "작업지휘자", input2: "김안전", input3: "", input4: "", input5: "", input6: "해당없음",},
        { input1: "유도자(신호)", input2: "김안전", input3: "", input4: "", input5: "",input6: "해당없음",},
        { input1: "작업자", input2: "박보건", input3: "", input4: "", input5: "", input6: "해당없음",},
        { input1: "작업자", input2: "", input3: "", input4: "", input5: "", input6: "",},
        { input1: "작업자", input2: "", input3: "", input4: "", input5: "", input6: "",},
        { input1: "조종(운전)자", input2: "", input3: "", input4: "", input5: "", input6: "기중기운전기능사 등",},
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    text-align: center;
    min-height: 60px;
    height: 60px;
    font-size: 14px;
  }
  th {
    background-color: #f9f9f9;
    font-weight: 500;
    padding: 0;
    word-break: keep-all;
  }
  td {
    min-width: 50px;
    word-break: keep-all;
    img {
      display: inline-block;
    }
  }
  .th-background {
    background-color: #f9f9f9;
    white-space: nowrap;
  }
  .check-container {
    padding: 10px 14px 0 14px;
    text-align: left;

    div {
      margin-bottom: 8px;
    }
    img {
      display: inline-block;
      margin-right: 8px;
    }
  }
  .text-left {
    text-align: left;
    padding: 10px 14px;
  }
}
.print-break {
  break-inside: avoid;
}
.print-break-page {
  page-break-before: always;
}


/* uploaded File */

.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__file {
    width: 100%;
    padding: 14px;
    height: 416px;
  }
}
</style>
